import { PosSelect, PosSelectProps } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';
import { DAY_OF_WEEK_TO_CID } from 'src/utils/constants/contentIdMaps';

import { DayOfWeek } from './DayOfWeek.types';

export type DayOfWeekSelectorProps = Omit<
  PosSelectProps,
  'valueOptionsContent'
> & {
  valueOptionsContent?: Record<DayOfWeek, string>;
};

export const DayOfWeekSelector = ({
  placeholderText = ContentId.All,
  valueOptionsContent,
  ...rest
}: DayOfWeekSelectorProps) => {
  return (
    <PosSelect
      style={{ width: '100%' }}
      {...rest}
      placeholderText={placeholderText}
      valueOptionsContent={valueOptionsContent ?? DAY_OF_WEEK_TO_CID}
      sortMode="none"
    />
  );
};
